import { render, staticRenderFns } from "./InventoryWidgetEad.vue?vue&type=template&id=b0543d62&"
import script from "./InventoryWidgetEad.vue?vue&type=script&lang=ts&"
export * from "./InventoryWidgetEad.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports